import { Module } from 'vuex'

import { SlogState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: SlogState = {
  isLogsLoading: false,
  logs: [],
}

export const slog: Module<SlogState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
